module.exports = __webpack_public_path__ + "static/media/gryphonhouse-adjusted-logo-gold.0540558f.png";